import * as React from "react"
import NewEvent from "./action-buttons/newEvent";
import EventListing from "./event-listing/eventListing";
import BasePage from "pages/common/basePage";
import Header from "pages/common/header";
import MainContent from "pages/common/mainContent";
import { connect, ConnectedProps } from "react-redux";
import { GlobalApplicationState } from "globalApplicationState";
import { RouteComponentProps } from "react-router";
import { getTopicFilters } from "modules/topics/utils/topicAttributeFetcher";

import "../styles/events.sass";

const EventManagementPage: React.FunctionComponent<PropsWithRedux> = ({ match }) => {

  return <BasePage fullWidth>
    <Header
      title="Manage Events"
      rightComponent={
        <NewEvent />
      }
    />
    <MainContent>
      <div className="authoring-page">
        <EventListing topicFilter={getTopicFilters()} eventIdToPreview={match.params.eventIdToPreview} />
      </div>
    </MainContent>
  </BasePage>;
}

interface RouteParams {
  eventIdToPreview: string;
}

interface IEventManagementPageProps {
}

const connector = connect(
  (state: GlobalApplicationState, ownProps: IEventManagementPageProps & RouteComponentProps<RouteParams>) => ({
    ...ownProps
  }),
  {
  }
);
type PropsWithRedux = ConnectedProps<typeof connector>;
export default connector(EventManagementPage);
